import { Tooltip } from "@mui/material";
import React, { ReactElement } from "react";

interface TooltipProps {
  title: string | number;
  placement?:
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";
  children: ReactElement<any, any>;
  bgColor?:string;
  fgColor?:string;
}

const CustomTooltip: React.FC<TooltipProps> = ({
  title,
  placement = "bottom",
  children,
  bgColor,
  fgColor
}) => {
  return (
    <Tooltip
      title={title}
      arrow
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: bgColor ? bgColor : "rgba(0, 0, 0, 0.7)",
            boxShadow: `rgba(0, 0, 0, 0.16) 0px 20px 40px -4px`,
            color: fgColor ? fgColor : "#ffffff",
            fontSize: "12px",
            fontFamily: "Ubuntu",
            fontWeight: "bold",
            borderRadius: "9px",
            backdropFilter: "blur(8px)",
          },
        },
        arrow: {
          sx: {
            color: bgColor ? bgColor : "rgba(0, 0, 0, 0.7)",
            m: 0,
            p: 0,
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
